import { addListener } from "@grindex-common/helpers/domManipulation";
import { Resolution } from "@grindex-common/helpers/Resolution.class";
import ImageCarouselDom from "./imageCarousel.dom";

const DEFAULT_SLIDE_COUNT = 5;
const DEFAULT_SLIDE_WIDTH = 111;

const SLIDE_MARGIN = 10;
const TOTAL_MARGIN = 64;
const SLIDE_TIMEOUT = 5000;
const MIN_SLIDES = 2;

function init($views) {
	$views.forEach(($view) => {
		const $module = $view;
		const dom = new ImageCarouselDom($module);
		const resolution = new Resolution();

		const nextSlideTimeout = [];
		const maxSlideCount = getThumbnailMaxSlideCount();
		const slideWidth = getThumbnailSlidesWidth();

		let maxSlides = maxSlideCount;

		const previewSliderConfig = buildPreviewSliderConfig();
		const thumbnailSliderConfig = buildThumbnailSliderConfig();

		const $previewSlider = dom.getPreviewSlider(previewSliderConfig);
		let $thumbnailSlider = dom.getThumbnailSlider(thumbnailSliderConfig);

		initEvents();

		startThumbnailSlideShow($previewSlider);

		function initEvents() {
			addListener(window, "resize", resize);
			addListener(dom.elements.nextButtonElement(), "click", stopThumbnailSlideShow);
			addListener(dom.elements.previousButtonElement(), "click", stopThumbnailSlideShow);
			addListener(dom.elements.previewSliderImageElements(), "click", stopThumbnailSlideShow);
			addListener(dom.elements.thumbnailSliderLinkElements(), "click", linkSliders);
		}

		function getThumbnailMaxSlideCount() {
			const count = dom.getThumbnailSlideCount();

			return count ? Number(count) : DEFAULT_SLIDE_COUNT;
		}

		function getThumbnailSlidesWidth() {
			const width = dom.getThumbnailSlidesWidth();

			return width ? Number(width) : DEFAULT_SLIDE_WIDTH;
		}

		function buildPreviewSliderConfig() {
			return {
				pager: false,
				infiniteLoop: false,
				hideControlOnEnd: true,
				onSliderLoad: function () {
					dom.elements.previewWrapperElement().style.visibility = "visible";
				},
				onSlideBefore: function (_$slideElement_notUsed, _oldIndex_notUsed, newIndex) {
					changeThumbnail(newIndex);
				}.bind(this),
			};
		}

		function buildThumbnailSliderConfig() {
			calculateMaxVisibleSlideCount();

			return {
				slideWidth: slideWidth,
				slideMargin: SLIDE_MARGIN,
				minSlides: MIN_SLIDES,
				maxSlides: maxSlides,
				pager: false,
				auto: false,
				infiniteLoop: false,
				hideControlOnEnd: true,
				moveSlides: 1,
				onSliderLoad: function () {
					dom.unselectAllPagerSliderListElementsExcept(0);
					dom.elements.thumbnailWrapperElement().style.visibility = "visible";
				},
			};
		}

		function resize() {
			if ($thumbnailSlider) {
				dom.resetThumbnailSlider();
			}

			$thumbnailSlider = dom.getThumbnailSlider(thumbnailSliderConfig);
			const currentSlide = $previewSlider.getCurrentSlide();
			changeThumbnail(currentSlide);
		}

		function calculateMaxVisibleSlideCount() {
			var calculatedSlideCount;
			const totalSlidesWidth = slideWidth + SLIDE_MARGIN;

			if (resolution.isLessThan(resolution.devices.desktopLarge)) {
				const availableWidth = window.innerWidth - TOTAL_MARGIN;

				// Calculate how many slides will fit, take at least default MinSlides
				calculatedSlideCount = Math.floor(availableWidth / totalSlidesWidth);
				maxSlides = Math.max(calculatedSlideCount, MIN_SLIDES);
			} else {
				maxSlides = maxSlideCount;
			}
		}

		function linkSliders(e) {
			e.preventDefault();
			stopThumbnailSlideShow();
			const newIndex = dom.getSlideIndex(e.currentTarget.parentElement);
			$previewSlider.goToSlide(newIndex);
		}

		function changeThumbnail(newIndex) {
			dom.unselectAllPagerSliderListElementsExcept(newIndex);

			// Check if carousel slide needs to be moved
			const newSlide = $thumbnailSlider.getSlideCount() - newIndex >= maxSlideCount ? newIndex : $thumbnailSlider.getSlideCount() - maxSlideCount;

			$thumbnailSlider.goToSlide(newSlide);
		}

		function stopThumbnailSlideShow() {
			nextSlideTimeout.forEach(function (id) {
				clearTimeout(id);
			});
			return;
		}

		function startThumbnailSlideShow(preview) {
			var i = 0;

			dom.elements.thumbnailSliderListElements().forEach(($sliderLi) => {
				const slideIndex = dom.getSlideIndex($sliderLi);
				nextSlideTimeout.push(
					setTimeout(function () {
						preview.goToSlide(slideIndex);
					}, i * SLIDE_TIMEOUT),
				);
				i += 1;
			});
		}
	});
}

export default {
	view: "imageCarousel",
	init,
};
